/**
Author - Brijesh Pandey
Git - https://bitbucket.org/__brijesh/
**/

import React, {useState, useRef} from "react";

import OurProducts from "./OurProducts";

const OurProductsContainer = () => {
  const [activeTab, setActiveTab] = useState(1);
  const tabContentRef = useRef("");

  return (
    <OurProducts
      activeTab={activeTab}
      setActiveTab={setActiveTab}
      tabContentRef={tabContentRef}
    />
  );
};

export default OurProductsContainer;
